<template>
    <div class="row font-20 font-medium justify-center mb-3">Thông tin thẻ kiểm soát</div>

    <div class="row">
        <div class="xs12">
            <DxValidationGroup ref="formValidationNhomThe">
                <div class="row">
                    <div class="xs12">
                        <DxSelectBox
                            label="Nhóm thẻ (*)"
                            v-model="ThongTinTheKiemSoat.IdNhomThe"
                            :dataSource="{
                                store: DanhSachNhomThe,
                                pageSize: 20,
                                paginate: true,
                            }"
                            display-expr="TenNhomThe"
                            value-expr="IdNhomThe"
                            :search-enabled="true"
                            styling-mode="outlined"
                            no-data-text="Không có dữ liệu!"
                            :onItemClick="onItemClickNhomThe"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                            </DxValidator>
                        </DxSelectBox>
                    </div>
                </div>
            </DxValidationGroup>
            <DxValidationGroup ref="formValidation">
                <div class="row mt-5">
                    <div class="xs12">
                        <DxTextBox
                            label="Ký hiệu thẻ (*)"
                            v-model="ThongTinTheKiemSoat.KyHieuThe"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                                <DxStringLengthRule
                                    :max="21"
                                    message="Không được vượt quá 21 ký tự!"
                                />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="xs12">
                        <DxTextBox
                            label="Mã thẻ (*)"
                            v-model="ThongTinTheKiemSoat.MaThe"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                                <DxStringLengthRule
                                    :max="50"
                                    message="Không được vượt quá 50 ký tự!"
                                />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
            </DxValidationGroup>
        </div>
    </div>

    <div class="row justify-space-between mt-3">
        <DxButton
            type="danger"
            text="Đóng"
            styling-mode="text"
            width="96px"
            @click="Dong"
        />
        <DxButton
            key="mdi-XACNHAN"
            type="default"
            text="Lưu thông tin"
            styling-mode="contained"
            @click="LuuThongTin()"
        />
    </div>
</template>
<script>
import {
    DxDataGrid,
    DxPaging,
    DxScrolling,
    DxColumnFixing,
    DxHeaderFilter,
    DxEditing,
    DxFilterRow,
    DxSelection,
    DxColumn,
    DxSummary,
    DxGroupItem,
    DxTotalItem,
} from "devextreme-vue/data-grid";
import {
    DxCheckBox,
    DxTextBox,
    DxSelectBox,
    DxValidationGroup,
    DxButton,
    DxValidator,
} from "devextreme-vue";
import {
    DxRequiredRule,
    DxStringLengthRule,
    DxNumericRule,
} from "devextreme-vue/validator";
import Devices from "@/functions/Devices.js";
export default {
    components: {
        DxTotalItem,
        DxDataGrid,
        DxPaging,
        DxScrolling,
        DxColumnFixing,
        DxHeaderFilter,
        DxEditing,
        DxFilterRow,
        DxSelection,
        DxColumn,
        DxSummary,
        DxGroupItem,
        DxCheckBox,
        DxSelectBox,
        DxTextBox,
        DxValidationGroup,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxStringLengthRule,
        DxNumericRule,
    },
    data() {
        return {
            DanhSachNhomThe: [],
            SuDungKyHieuTuDong: true,
            IsDangThemThe: false,
            NhomTheDangChon: null,
        };
    },
    computed: {
        ThongTinTheKiemSoat: {
            get() {
                return this.$store.state.TheKiemSoat.ThongTinTheKiemSoat;
            },
            set(data) {
                this.$store.commit("TheKiemSoat/Set", {
                    key: "ThongTinTheKiemSoat",
                    data: data,
                });
            },
        },
    },
    methods: {
        Dong() {
            this.$emit("hiddenPopup", "PopupSuaThongTinTheKiemSoat");
        },
        onItemClickNhomThe(e) {
            if (e.itemData) {
                this.NhomTheDangChon = e.itemData;
            }
        },
        LuuThongTin() {
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.ThucHienLuuThongTin();
        },
        async ThucHienLuuThongTin() {
            try {
                this.$startLoading;
                let rs;
                rs = await this.$store.dispatch("TheKiemSoat/CapNhatTheKiemSoat");
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Lưu thông tin thẻ kiểm soát thành công!"
                    );
                    this.Dong();
                    this.$emit("getData");
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Lưu thông tin thẻ kiểm soát thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Lưu thông tin thẻ kiểm soát thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
        async LayDanhSachNhomThe() {
            try {
                this.DanhSachNhomThe = (
                    await this.$store.dispatch("NhomThe/LayDanhSachNhomThe")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        ConnectCardReader() {
            let self = this;
            let arrCard = JSON.parse($app.readFile("CFG-DauDocThe.json")) || [];
            let checkId = null;
            let num = 0;
            self.conn.CardReaders().Status(function (id) {
                checkId = id;
                if (checkId) {
                    self.$Helper.ThongBaoToast(
                        "success",
                        "Kết nối đầu đọc thẻ " + (num + 1) + " thành công!"
                    );
                } else {
                    self.$Helper.ThongBaoToast(
                        "error",
                        "Kết nối đầu đọc thẻ " + (num + 1) + " thất bại!"
                    );
                }
                num++;
                // self.pingCardReader();
            });
            setTimeout(() => {
                arrCard.forEach((e) => {
                    self.conn.Connects("CardReader", e);
                });
            }, 0);
        },
        DisconnectCardReader() {
            let self = this;
            let arrCard = JSON.parse($app.readFile("CFG-DauDocThe.json")) || [];
            let list_id = {
                CardReader: [],
            };
            arrCard.forEach((e) => {
                list_id.CardReader.push(e.MaDauDocThe);
            });
            self.conn.DisConnects(list_id);
        },
    },
    async created() {
        this.LayDanhSachNhomThe();
        let self = this;
        if (this.$Core?.App?.IsNative) {
            self.conn = new Devices();

            // Kết nối đầu đọc thẻ - start
            await new Promise((resolve) => setTimeout(resolve, 0));
            self.DisconnectCardReader();

            await new Promise((resolve) => setTimeout(resolve, 0));
            self.ConnectCardReader();

            await new Promise((resolve) => setTimeout(resolve, 0));
            self.conn.CardReaders().Scan(async function (MaThe) {
                self.ThongTinTheKiemSoat.MaThe = MaThe || self.ThongTinTheKiemSoat.MaThe;
            });
        }
    },
    mounted() {},
    beforeUnmount() {
        if (this.$Core?.App?.IsNative) {
            this.DisconnectCardReader();
        }
    },
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
